// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"450c26e0","374":"7abc7ebf","429":"64d32bd5","432":"f02c2552","446":"1dbb7a7b","453":"b6e93864","507":"73e18e2b","696":"91ce43e1","923":"f0062c9e"}[chunkId] + ".chunk.js";
};